<template lang="pug">
  // 仅为了打包这样做
  span(class="taskImage")
    img(v-if="flag === 'monster-1'", src="~assets/space/monster-1.png")
    img(v-if="flag === 'monster-2'", src="~assets/space/monster-2.png")
    img(v-if="flag === 'monster-3'", src="~assets/space/monster-3.png")
    img(v-if="flag === 'monster-4'", src="~assets/space/monster-4.png")
    img(v-if="flag === 'monster-gray-1'", src="~assets/space/monster-gray-1.png")
    img(v-if="flag === 'monster-gray-2'", src="~assets/space/monster-gray-2.png")
    img(v-if="flag === 'monster-gray-3'", src="~assets/space/monster-gray-3.png")
    img(v-if="flag === 'monster-gray-4'", src="~assets/space/monster-gray-4.png")
    img(v-if="flag === 'venue-1'", src="~assets/space/venue-1.png")
    img(v-if="flag === 'venue-2'", src="~assets/space/venue-2.png")
    img(v-if="flag === 'venue-3'", src="~assets/space/venue-3.png")
    img(v-if="flag === 'venue-4'", src="~assets/space/venue-4.png")
    img(v-if="flag === 'venue-gray-1'", src="~assets/space/venue-gray-1.png")
    img(v-if="flag === 'venue-gray-2'", src="~assets/space/venue-gray-2.png")
    img(v-if="flag === 'venue-gray-3'", src="~assets/space/venue-gray-3.png")
    img(v-if="flag === 'venue-gray-4'", src="~assets/space/venue-gray-4.png")
  </template>
  <script>
  export default {
    name: 'TaskImage',
    props: {
      flag: String,
    },
    data() {
      return {}
    },
    computed: {},
    methods: {},
  }
  </script>
  
  <style scoped lang="sass">
  @import "src/styles/common"
  @import "src/styles/footprint"
  .taskImage img
    width: 100%
  </style>
  